import { cn } from "@/shared/utils/cn";
import { PollStatus } from "@/shared/utils/interfaces";
import { useTranslation } from "react-i18next";

const statusClassName: Record<PollStatus, string> = {
  [PollStatus.ACTIVE]: "bg-success",
  [PollStatus.SCHEDULED]: "bg-primary",
  [PollStatus.ENDED]: "bg-text-tertiary",
};

const PollStatusLabel = ({ status }: { status: PollStatus }) => {
  const { t } = useTranslation("", { keyPrefix: "polls.statuses" });

  return (
    <span
      className={cn(
        "inline-block whitespace-nowrap rounded-full px-3 py-1 text-small font-semibold text-white",
        statusClassName[status]
      )}
    >
      {t(status)}
    </span>
  );
};

export default PollStatusLabel;
